import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ROLE_CONSTANTS } from "@/modules/Roles/constants/RoleConstants";
import ViewButton from "@/shared/components/ViewButton/ViewButton.vue";
import { ReferenceDataAccess } from "./../../models/ReferenceData";

@Component({
  name: "SidePanelPermissionCard",
  components: {
    ViewButton
  }
})
export default class SidePanelPermissionCard extends Vue {
  @Prop() referenceDataAccess!: ReferenceDataAccess;
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD_2;
  card2Class = STYLE_CLASSES.CARD_PADING;
  ROLE_CONST = ROLE_CONSTANTS.PERMISSION_SIDE_PANEL_CARD;

  selectDisplay(id: string) {
    this.$emit("onDisplay", id);
  }
}
